export enum DeclarantLanguage {
  enGB = 'en-GB',
  deDE = 'de-DE',
  esES = 'es-ES'
}

export enum OperatorLanguage {
  enGB = 'en-GB',
  trTR = 'tr-TR',
  zhCN = 'zh-CN'
}
